/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../../../utils/config';

export const FIBER_SITES_PUBLIC_IP_URL = `${API_URL}/fibersites/publicip`;
